// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import { XNGAGE_CUSTOM_WIDGET } from "@conklin/XDL/constants";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

const enum fields {
    defaultPageSize = "defaultPageSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.defaultPageSize]: number;
    };
}

interface NewsListContainerStyles {
    wrapper?: InjectableCss;
    sideBar?: InjectableCss;
    content?: InjectableCss;
    filterWrapper?: InjectableCss;
}

export const newsListContainerStyles: NewsListContainerStyles = {};

const styles = newsListContainerStyles;

type Props = OwnProps;

const NewsListContainer: FC<Props> = ({ id, fields: { defaultPageSize } }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.sideBar}>
                <StyledWrapper {...styles.filterWrapper}>
                    {createWidgetElement("NewsList/NewsListFilter", {
                        fields: { accordionExpanded: true, showMoreExpanded: true },
                    })}
                </StyledWrapper>
                <XngZone contentId={id} zoneName="sideBar"></XngZone>
            </StyledWrapper>
            <StyledWrapper {...styles.content}>
                <XngZone contentId={id} zoneName="content"></XngZone>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const NewsListContainerWidget: WidgetModule = {
    component: NewsListContainer,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
        fieldDefinitions: [
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 12,
                fieldType: "General",
            },
        ],
    },
};

export default NewsListContainerWidget;
